module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chap",
    attrs: {
      "epub:type": "chapter",
      "id": "chap-001",
      "role": "doc-chapter"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "role": "doc-pagebreak",
      "title": "21"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _vm._v(" "), _c('h2', {
    staticClass: "chap_n",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "rp_21"
    }
  }, [_vm._v("CHAPTER ONE")])])]), _c('a', {
    attrs: {
      "id": "rp_21"
    }
  }, [_c('h2', {
    staticClass: "chap_tit",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_c('span', [_vm._v("RIVER, the WOMB,"), _c('br'), _vm._v("and HEARTH")])]), _vm._v(" "), _c('h2', {
    staticClass: "chap_stit",
    attrs: {
      "epub:type": "subtitle",
      "lang": "en-US",
      "role": "doc-subtitle"
    }
  }, [_c('span', [_vm._v("A Meditation on the Constraints of the Church")])]), _vm._v(" "), _c('div', {
    staticClass: "exergues"
  }, [_c('div', {
    staticClass: "exer"
  }, [_c('p', {
    staticClass: "txt_courant_centre last",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('i', [_vm._v("Some tear away from her and attack her and break her established rules. They abandon the maternal womb and the sweet nourishment of the church.")])]), _vm._v(" "), _c('div', {
    staticClass: "exer_source",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('b', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILDEGARD VON")]), _vm._v(" B"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INGEN")]), _vm._v(","), _c('br'), _vm._v("\n        D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCTOR OF THE")]), _vm._v(" U"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIVERSAL")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HURCH")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapeau"
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "fig-002_2",
      "role": "presentation",
      "src": "images/p1.jpg"
    }
  })])])]), _c('div', {
    staticClass: "dev"
  }, [_c('a', {
    attrs: {
      "id": "rp_21"
    }
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "let"
  }, [_vm._v("T")]), _vm._v("he church in America is having a moment. Some of our difficulties have been made more poignant by the Covid-19 pandemic, political divisions, and the emergence of #ChurchToo stories of sexual abuse and cover up. We are in the middle of a reckoning. But none of the challenges the church has seen in the past few years are the cause of the reckoning.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The things in our life that we cannot see have great power. Sometimes we get a look at what lies beneath slowly over time "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "role": "doc-pagebreak",
      "title": "22"
    }
  }, [_vm._v("through practices of paying deeper attention, and sometimes it just surfaces all at once. The church in America is having an all-at-once moment. We are clearly learning that our way of life—our way of being the church—has not produced the kind of Jesus-followers we have hoped for. Even some who were tasked with leading, pastoring, and caring for us have proven unreliable.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("My prayer for the church is that this moment be more than a reckoning. Perhaps it could be another Reformation. But first we have to be honest about what is actually happening. We have to deal with reality.")])]), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "rp_21"
    }
  }, [_vm._v("We are living through a moment when many are deconstructing their Christian faith and abandoning, as Hildegard von Bingen called it, “the maternal womb and the sweet nourishment of the church.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "epub:type": "noteref",
      "href": "#/appen3#ntf-010",
      "id": "ap_ntf-010-1",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" I can’t necessarily fault them. The carnage and misunderstanding around the so-called deconstruction project only illustrates the point that has led to so many people walking away from church: it has not been a safe place for those who have questions about doctrine, anger about cover ups, and little hope that we will ever be able to detox from the power, money, and exploitation that is woven into the fabric of the church in America.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("As I write, I wonder how a book on constraint and spiritual practices could begin to be helpful, given how much of the deconstruction conversation centers around the unhelpful (to some) and unhealthy (real or perceived) constraints and rigidity of certain pockets of the church.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I have hope and a vision for a church that leans into spiritual practices in healthy ways—ways that invite people into deeper commitment. We can learn how to invite people into deeper practice without exerting power over them.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But first we need to bind up some wounds.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "role": "doc-pagebreak",
      "title": "23"
    }
  }, [_vm._v("This chapter is both for those who love the church and for those leaving it. Most particularly, it is for those who think that by leaving the church they are loving it more. I believe we are living in a moment of reformation. This is my invitation for you to stay in the church—perhaps in some creative ways. It’s also meant to be a pushback on church leaders who are dismissive of those wanting to leave it.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("If you are wondering if a metaphor can save your faith (or maybe your faith in the church)—I have three of them that I think could, at the very least, be helpful.")]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_vm._v("The Church as River—and the Banks of Deconstruction")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There is a river in Peru that you have probably never heard of. It’s the main headstream of the Amazon River, which you certainly have heard of. The Ucayali River has received some attention recently from geologists because we are now able to see how the surface of the earth is changing and how those changes—in vegetation, glacial melting, and even the emergence of new cities—impact the flow of rivers. The shape of the Ucayali River is changing at an impressive speed and through thirty years of satellite images, scientists are able to visualize and predict those changes and look closer at the “meander migration rate” of the river whose waters eventually flow into the Amazon."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "epub:type": "noteref",
      "href": "#/appen3#ntf-011",
      "id": "ap_ntf-011-1",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The banks of the river give way to its surroundings and the river spills out and forms new bends and necks and chutes. The flow of the river in general is "), _c('i', [_vm._v("constrained")]), _vm._v(" by the banks of the river, and the banks of the river respond to the surrounding changes. And yet the river never stops flowing. Some new bends disappear and dry up. Some old banks get eroded. But the direction of the river "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "role": "doc-pagebreak",
      "title": "24"
    }
  }, [_vm._v("does not change. The waters end up flowing more or less along the same path.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The church is a river that started as a small stream, birthed by the Spirit, on the day of Pentecost. We are meant to be, as the psalmist says, “a river whose streams make glad the city of God” ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Ps+46%3A4&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Ps 46:4")]), _vm._v("). We are meant to be the place where the presence of God dwells. We carry the water of life, which is the Holy Spirit, and that water nourishes trees of life, which bear all kinds of fruit. The leaves of those trees are for the healing of the nations ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Rev+22%3A2&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Rev 22:2")]), _vm._v("). This is the glorious vision given to us in the revelation of John and, long before him, through a vision in Ezekiel ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Ezek+47&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Ezek 47")]), _vm._v(")—a vision of water spilling out of the temple (which we now know to be both the body of Christ and his church), flowing under the threshold and expanding into the whole world, where every living creature who comes in contact with it will have life abundant.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But what happens when the banks of the river begin to collapse due to weakness? Or the waters of the river become so strong that they spill out and begin to bend the river in a new direction? You might fear that the banks of the river—the strong constraints of the church—are crumbling. People are asking questions about long-held doctrines and teachings of the church and many others are walking through a process of deconstruction. Few pastors know what to do with it all. The once-sturdy banks that held the water of faith for many are shifting in some places. And the questions people are asking and the conclusions they are coming to feel incongruent with the story as it has been told thus far. Theologians and laypeople alike are standing in the waters of the river, which seem to be cresting the banks and overflowing the constraints the church has provided.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "role": "doc-pagebreak",
      "title": "25"
    }
  }, [_vm._v("Maybe you are looking for ways for the banks to be reshaped so the water can overflow them. Perhaps you see something on the horizon that others are unable to see. You have prayerfully reached conclusions that make others uncomfortable, and you wonder if the church can hold space for the questions you are asking and the tentative conclusions you are reaching. You hold big questions about last things and eternal places. You wonder how the death of Christ brings salvation and healing. And you have questions about human sexuality and the authority of Scripture—and how to think about these in relation to your queer friends and gay neighbors. You might feel frustrated by the slowness of change. You’ve probably thought about leaving the church. Or perhaps you have already done so.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This moment is one of incredible tension. The river is rushing, the rapids are churning, and we are either headed for a giant flood or damming barrier or bifurcation. The tension is between strict and sturdy banks and the waters that overflow them (as they sometimes should). But this is not a new phenomenon within the church. This is what the church has always been. It has always been a river whose banks are being defined and redefined in an ongoing process of discernment. At our best, we have done this alongside the Spirit, interpreting the Scriptures, living in and responding to the world around us, while loving one another. At our worst, we have done it with a tremendous exertion of power over people.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("However the future unfolds, I pray that we not exert power over one another during this season of deconstruction and reformation. If you are a church leader or pastor, I invite you to consider a constraint on your exertion of power over others.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_26",
      "role": "doc-pagebreak",
      "title": "26"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_vm._v("The Early Years")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("When we think about the early years of the church, we often sigh with relief when we come to the first ecumenical council at Nicaea, where the sturdy banks of the river began to be formed. The Nicene Creed, which eventually provided a benchmark for orthodoxy, was the primary artifact that emerged from the council. In it we find a sense of settledness around important doctrines that we now simply take for granted.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What we often overlook is that coming to some final conclusions around some of the words that would make it into the creed was quite tumultuous for the church. There were some “conservatives” who did not want to accept the wording about Jesus being “one in being with the Father.” It took another 350 years for the turbulent waters of the river to settle and the doctrinal banks of the river to stabilize. For much of the fifth, sixth, and seventh centuries, the battles over the nature of Christ—his humanity, his divinity"), _c('i', [_vm._v(",")]), _vm._v(" and how those two could be held together in one body—splintered the church. The waters sometimes overflowed the banks. And sometimes they receded. Friendships were lost, men were murdered, and emperors were conscripted into doctrinal battles.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Maximus the Confessor lived most of his life as a monk in prayer, study, and constraint. He became connected with the theological traditions that informed those early formulations of the nature of Christ that we find in those first creeds. This issue was highly significant for the early church fathers, and it became important for Maximus, who courageously inserted himself into the debate when it became clear that the majority view was not aligned with what was penned at that first council and ratified at the second. Whatever sturdy banks existed at the end of the fourth "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_27",
      "role": "doc-pagebreak",
      "title": "27"
    }
  }, [_vm._v("century were on the verge of collapse. Maximus could not remain silent, so around the year 640, he began to speak out against a popular view that was held by the majority of those in power. He did so in a time when speaking out against those with ecclesial and political power could get you “canceled” in ways that we can’t even begin to understand. People were sent to islands to die for not conforming.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For nearly fifteen years Maximus quietly opposed some of the theological changes that were making the rounds. He argued for a return to orthodoxy as established by the first and second ecumenical councils. Whatever this new bend in the river was, for Maximus it was taking the whole river in a dangerous direction. In 655 he was arrested, brought to trial for treason, and accused of heresy. Every attempt to persuade Maximus of the truth of the “emerging view” failed. He was brought to Constantinople where he was tortured for his “heresy.” They cut out his tongue to prevent him from speaking, and they cut off his right hand so that he could not write to defend his position. He was exiled to a distant place where he died nearly a decade later with two disciples by his side. Within twenty years of his death, the teaching for which he had given his life was vindicated at the sixth ecumenical council. The “majority opinion” in Maximus’s world turned out to be wrong.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Where do we fit into this story? It’s a good question for us to think about, particularly if we find ourselves in the midst of chipping away at the banks of the river on the one hand, or trying to keep the water at bay on the other. This analogy of the church as a river, moving in a particular direction, whose banks and boundaries are in flux gives us at least two things to consider as we move forward.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_28",
      "role": "doc-pagebreak",
      "title": "28"
    }
  }, [_vm._v("First, some riverbanks are negotiable, and the church’s task is ongoing discernment. Discernment of the Scriptures keeps the river flowing, and this has always been done as a collective people in ongoing presence to one another and love for one another. This process is often slow, and we can allow this slow process to constrain us.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Sometimes the banks of the river are held in place by the institution of the church. And sometimes that same institutional structure keeps a bank intact that later generations find unnecessary. We live in the church, and the church is a place of contradiction because, for example, in some parts women can preach and in other parts they are not allowed to preach. From early on the church has convened councils, appointed leaders, commissioned preachers, discerned theological necessities, and drawn boundaries in various places. All have shaped the flow of the river.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Sometimes we look back at earlier decisions and see where the church has made adjustments. We widen the banks in places and counteract erosion in others. Sometimes we can see more clearly than those who came before us, and sometimes our vision has become less clear and we must return to the foundation that has come before us. Navigating this process has always been one of the tasks of the church. This has happened in areas of theology (have you recently met a Monophysite?), worship (the iconoclast debate raged for centuries), and even social and ethical teachings (the first church institution to give a thumbs up to any form of contraception was the Anglican Church in 1930). The church has been at the task of negotiation and discernment from the very beginning.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("What we need is patience.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But we also sometimes need impatience. Yes, there are places in this negotiation process where we need to allow things to "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_29",
      "role": "doc-pagebreak",
      "title": "29"
    }
  }, [_vm._v("unfold slowly. But there are other places where we need voices (particularly ones that have been suppressed) to speak loudly and disruptively and to cause conflict.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("We find ourselves in a moment where there is a great temptation to hang on to power (if we have it) or exercise the only last freedom we believe we have (if we don’t have power)—which is the freedom to leave. The gift of constraint is that we can both constrain our power (if we have it) and allow ourselves to be constrained by the church (if we do not have the power to change it) so that when the time is right, we are still in the river when it shifts in the direction guided by the Spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("We can learn to relinquish that particular kind of power that can become toxic and controlling. We can make more room for the marginalized voices of those who can see what others may not yet be able to see. We can stay in the river and do the hard work of confrontation. I’m inspired by the many people who are doing this while not giving up on the church.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This does not mean that anyone should stay in a section of the river that has become toxic. There are traditions and teachings within the church that are harmful and will soon dry up. There are systems and leaders that are toxic. If this is where you are, find a boat and row for fresher waters. If you want to row out of the boundaries of a particular denominational structure, this doesn’t mean you have to leave the broader constraints of the historic church. The river is wide and is fed by fresh springs in so many places. Find a church that you can heal in, but please stay in the waters.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Second, the negotiation process goes better with humility—both in those who want to keep everything the same and those who want to bend the banks in a particular direction.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_30",
      "role": "doc-pagebreak",
      "title": "30"
    }
  }, [_vm._v("So many of the issues we face today over contentious topics are difficult to talk about without producing a dumpster fire on Twitter. Issues of human sexuality and identity, the role of women in the church and feminism, critical race theory and racial justice, to name just a few, are not going away—we will continue to need to navigate these issues. I hope this process is one where we do not cut out tongues and chop off hands. We have our own culturally bound ways of succumbing to this behavior. This doesn’t mean that we can’t say what we think and draw boundaries and articulate how we read the Scriptures, but I hope we can do so with a greater degree of humility.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The constraints of the church—the historic creeds, the traditions of reading the Scriptures, care for the poor, and the shared commitment to the praise of God—provide basic boundaries for the river of God’s unending love to flow into the world. It’s a mess of a river right now, but stay in it—part of that mess may help us grow into what we were always intended to be.")])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_vm._v("The Church as Womb")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There are a lot of metaphors in Scripture for the work of the church. One of the earliest is the church as mother and ourselves as preborn babies. We are within the church’s womb being formed into what we were always meant to become—human beings"), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I learned of this metaphor in a graduate course with Orthodox theologian Fr. John Behr. It has nudged me toward an imaginative framework where I can, at least in a thought experiment, begin with the possibility that I am not yet a human but am on my way toward becoming one through the nourishment of the church. The most beautiful thing about this image, as Fr. Behr points out, is that we are the recipients of care and nourishment.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_31",
      "role": "doc-pagebreak",
      "title": "31"
    }
  }, [_vm._v("So much of our talk about following Jesus is framed in terms of "), _c('i', [_vm._v("mission.")]), _vm._v(" We are enfolded into a great family spread across time and place, and we have a job to do. The family business is mission. This, of course, is all true. The church is joining God on mission to the world, which is why we often gravitate to sermons and books that help teach us how to enact our faith outwardly and join God on God’s mission.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But the vision of the church as a mother helps us grow deeper into the reality that the totality of our Christian experience is not focused on accomplishing a task. What we often overlook in our pursuit of the mission is that something is happening "), _c('i', [_vm._v("to")]), _vm._v(" us. And this work of formation is ongoing until we are born again at our death, in resurrection, when the fullness of time and maturation is complete. We typically think of ourselves as already being human; being “born again” happens at baptism when we receive the Holy Spirit. But let’s consider that everything that is happening in our life and all the ways we are learning to love and forgive, rejoice and grieve, hold on to and let go of, are happening within the womb. The church is our mother."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "epub:type": "noteref",
      "href": "#/appen3#ntf-012",
      "id": "ap_ntf-012-1",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Spiritual formation is not a solo expedition. It is primarily communal. The people of the church are the womb of our formation. And, of course, when those people gather together, leadership is required, and so we have people "), _c('i', [_vm._v("and")]), _vm._v(" an institution.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This is where the tension emerges between exercising one’s individual freedom and renouncing some of that individual freedom for the sake of the whole. When we entrust leadership to pastors and leaders and overseers, we are handing over some level of authority to the church as our mother. Many modern Americans will hate this choice and try to find a way around it "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_32",
      "role": "doc-pagebreak",
      "title": "32"
    }
  }, [_vm._v("simply because we’ve been led to believe that freedom is equal to the absence of constraints.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There is no way around this tension. Community is not possible for people who are first and foremost committed to living without constraint. The only way community is possible is for people to negotiate a healthy relinquishment of some things for the sake of other things that serve the whole community. A failure to live in this tension is the primary reason that American evangelicalism feels like it might be collapsing.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I’m offering a different vision of freedom. It is the freedom found "), _c('i', [_vm._v("within")]), _vm._v(" the constraints. The scary thing about community and institutions that provide concrete actions for the people within community is that leaders must also be committed to the constraints of leadership. And when we aren’t committed to the constraints of the pastoral vocation, we end up with a variety of abuses. Leaders are meant to serve those they are leading, which sometimes means asking people to do things that they do not really (at first) want to do. But leaders also bear the responsibility of shaping a community as a womb—not as a gauntlet.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This is not necessarily a book about leadership. But there are practices here that will make you a better leader as you bring others into your life in an intimate way to practice together. I believe if you do so, it will help make your church into a womb where people can grow.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The church is often pushing people out of the womb who don’t quite carry the exact DNA that they or we are looking for. We need to create a more spacious room because the people we push out probably have a lot to teach us. I am not advocating for throwing out orthodoxy for the sake of accommodation. But we "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_33",
      "role": "doc-pagebreak",
      "title": "33"
    }
  }, [_vm._v("need more space for people who are asking hard questions and going through deconstruction.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("If you are one of those people who feel pushed out too soon, I’m sorry. I want you to have a womb where you can be formed in the way of Jesus.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Recently a friend in a small Midwestern city told me that for nearly three years they have been looking for a church that believes in the resurrection, prays for the sick, cares for the poor (including refugees), and isn’t hitched to the wagon of Christian nationalism. They simply cannot find a church in their city that is passionate enough about the things of Jesus and dispassionate enough about who is going to be the next president. I talk with people all across the country who share this same story. We’re in a historic moment that will require a new way of staying in the river—which is actually quite old. We will need to build some new structures and institutions that nurture our formation within the womb of the church.")])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-008"
    }
  }, [_c('h3', {
    staticClass: "int_niv1",
    attrs: {
      "epub:type": "title",
      "lang": "en-US"
    }
  }, [_vm._v("The Church as a Hearth: That I Might Become “All Flame”")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There’s a story in "), _c('i', [_vm._v("The Sayings of the Desert Fathers")]), _vm._v(" that goes like this:")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea last retrait_autre",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Abba Lot went to Abba Joseph and said to him, “Abba, as far as I can I say my little office, I fast a little, I pray and meditate, I live in peace and as far as I can, I purify my thoughts. What else can I do?” Then the old man stood up and stretched his hands towards heaven. His fingers became like ten lamps of fire and he said to him, “If you will, you can become all flame.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "epub:type": "noteref",
      "href": "#/appen3#ntf-013",
      "id": "ap_ntf-013-1",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "role": "doc-pagebreak",
      "title": "34"
    }
  }, [_vm._v("When I was sixteen years old, I came into a Vineyard church from a nearby Nazarene church that was a womb to me at the beginning of my faith. I came to Christ in that Nazarene church, with a gospel presentation and an altar call.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("My conversion was a moment. I was twelve or thirteen years old. I felt the weight of God come upon me, was filled with the Holy Spirit, and fell to my knees and wept uncontrollably at the grace of God. I needed it more than I needed anything. Even as I write this I am filled with tears of gratitude. I cannot tell this story without weeping because whatever began in me that day has been a relentless healing of wounds and an ongoing invitation to be filled up with the love of God.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I know that not every conversion story is this dramatic. But mine was.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("So when I walked into a Vineyard church as a teenager a few years later, whatever I had experienced in my conversion—that overwhelming sense of God’s love for me—by this time was more or less a distant memory. It was the worship that got me. I opened up my hands and turned them upward near my waist, and God filled those hands with his love and then dumped the rest of it on top of me, and I began to weep again, standing in the love of God. Something new was birthed within the global church in those years. And this new style of worship that was being nurtured in and through the Vineyard movement seemed to be somewhere near the center of it. At least it was for me.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In different seasons—though not in every season, as I’ve been through my own radical deconstruction/reconstruction—I have felt as though God’s own self was on fire inside of me. If the church had not guided me into the tradition and given me an array of perspectives on the Scriptures, teaching me to read and meditate "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "role": "doc-pagebreak",
      "title": "35"
    }
  }, [_vm._v("on the story handed down to us, the deconstruction I faced in the spring of 2002 would likely have burned up my life.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“All flame” means to allow the love of God to consume all that is not of God and to burn and to give off heat and light and draw the world toward the love of God with one’s life. But, in order to burn this hot, we need a hearth.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This last metaphor that I offer is the idea that we are meant to burn with the fire of God’s very own being, and that the church, at her best, will help that fire burn as hot as possible. If you have ever warmed yourself in front of a fire in someone’s home, it was probably contained by a hearth. The hearth is the structure of bricks or stones surrounding the fire that keeps it (and the wood that fuels it) contained. A fire burns hotter when it is constrained within a structure of bricks or stone. There are even ways you can design a hearth to hold the heat of the fire—bricks and stones provide a thermal mass that absorbs the heat—and to throw that heat out into the room. The church can be a hearth that holds the fire of God’s love, burning with you, among you, and between the other people in your life.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Can you imagine the church being a place that helps you burn hotter—as a community that absorbs that heat of the love of God together and reflects that heat out into the rest of the world?")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The temptation in this historic moment of church reformation, widespread pastoral failures, denominational failures, faith deconstruction, and the realization that perhaps we have not created churches in which people are able to become “all flame” is either to jump from church to church looking for heat or try to burn as hot as we can all alone.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But starting a fire requires more than one piece of wood, and you have to start with small twigs and sticks and gently blow. And "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "role": "doc-pagebreak",
      "title": "36"
    }
  }, [_vm._v("that is a lot of work for one person. If you are in a local church, you might consider grabbing a few friends and leaning into the practices within this book. This isn’t the only way to start a fire, but if a few people within your community begin to live deeply into sharing vulnerably about the experience of the practices of constraint, you might end up sparking something.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The hope is then that your church could build a hearth to help you all burn even hotter. One of the most radical and helpful things you could do for your local church is to gather some others around you and pray together to become inflamed with the love of God. My deepest prayer in this season is that God will create little pockets of people who desire to become all flame.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("If you are reading this and you have not yet returned to a local church in this post-pandemic age, there could be a temptation to just gather a few people in your living room, untethered from the church in any institutional or formal way.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("You could begin there, I think. My caution is that in the long run this could feel like trying to build a fire in your living room without a hearth. I suppose it might work in the short run. But without a proper hearth, either the fire will be short lived or there is some chance that you might burn down your house.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The analogy might be breaking down a bit, but I want to say this: As broken and lost as the church in the West feels in this moment, we must learn to love her. Whatever we think about the institution of the church, if we are to have God as our Father, then, according to the tradition, we have the church as our mother.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There is a tradition within the church that has emerged throughout its history in moments of crisis. There are these moments in the history of the church when a small but prophetic charism emerges that invites people to burn a bit hotter, and it "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_37",
      "role": "doc-pagebreak",
      "title": "37"
    }
  }, [_vm._v("builds hearths for them to do so. We are in one of those moments. We are confronted with a growing awareness that the present typical forms of church simply cannot or will not allow us to become "), _c('i', [_vm._v("all flame.")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But we do not need to leave the church to find the hearth. The traditions of monastic movements and religious orders, which are not outside but inside the church, have been building hearths for men and women since the fourth century. Religious orders, in all their forms—Jesuits, Dominicans, Cistercians, Franciscans, to name a few—share a particular spiritual framework for transformation and mission. They have found a way to help people burn hot.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Bring people together around the practice of constraints to nurture the experience of the love of God, and they will help one another catch fire. And the heat of these few who choose to live a deeper, more prophetic life end up warming the church.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Invite people to drink from the source of the river of the practices of the early church—a faith that embraced martyrdom—and they will have a chance to become all flame.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Create contexts to reflect the heat of God’s love through these men and women into the world, and they will become what all of us were always meant to be—what Jesus said we would be—a light to the world ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Mt+5%3A14&version=NIV",
      "target": "_blank"
    }
  }, [_vm._v("Mt 5:14")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It is to the practice of this tradition that we now turn.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09c64d8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap1.vue
// module id = 75
// module chunks = 0